import BetSlipApiService from "@api-services/agency/BetSlipApiService";
import { BetSlipExtended } from "@api-types/agency/bet-slip";
import { BetSlipCombinations } from "@api-types/bet-slip/BetSlipCombinations";
import { UserTypes } from "@utils";
import { Bet } from "@models";
import { Filter } from "@api-types/my-bets/Filter";
import { BetSlipShare } from "@models/BetSlipShare";
import { mapBetSlipOffers } from "@utils/my-bets/helpers";

export default class BetSlipService {
	static async findBets(
		filter: Filter | null = null,
		page: number | null = 1,
		rpp: number = 10,
		activeUser: UserTypes = UserTypes.PRIMARY,
		sort: string = "dateCreated|desc"
	): Promise<Bet[]> {
		const response = await BetSlipApiService.findBets(
			filter,
			page,
			rpp,
			activeUser,
			sort
		);
		response.item?.forEach((betSlip) => {
			mapBetSlipOffers(betSlip);
		});
		return response.item.map((item) => new Bet(item));
	}

	static async getSharedBetSlip(
		betSlipNumber: string
	): Promise<BetSlipShare> {
		const response = await BetSlipApiService.getSharedBetSlip(
			betSlipNumber
		);
		mapBetSlipOffers(response);
		return new BetSlipShare(response);
	}

	static async getSystemCombinations(
		id: string,
		activeUser = UserTypes.PRIMARY
	): Promise<BetSlipCombinations[]> {
		const response = await BetSlipApiService.getSystemCombinations(
			id,
			activeUser
		);

		return response;
	}
}
